import {
    apiClient,
} from '@/shared/api'

export interface CurrentUser {
    authenticationId : string
    userName : string
    email : string 
}

export function getCurrentUser():
    Promise<CurrentUser> {
    return apiClient.get<CurrentUser>(
        '/authentication/me',
    )
}